@if (selectFullPagePending$ | async) {
  <div class="loading-overlay">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
}
<router-outlet></router-outlet>
